import { useEffect, useRef } from 'react';
/**
 * 渲染完成时，显示某个属性不再支持
 * @param comp 组件名称
 * @param props props
 * @param oldName 旧属性
 * @param newName 新属性
 */
export function useDeprecated(comp, props, oldName, newName, defaultValue) {
    useEffect(() => {
        if (oldName in props && console && console.warn) {
            console.warn(`Warning: ${comp}.${oldName} is deprecated and will be removed in a future version, please use ${newName} instead`);
        }
    }, []);
    // 旧属性兼容
    if (newName in props) {
        return props[newName];
    }
    if (oldName in props) {
        return props[oldName];
    }
    return defaultValue;
}
let counter = 0;
export function guid(prefix = '') {
    counter += 1;
    return `${prefix}${counter}`;
}
export function useGuid(prefix = '') {
    const id = useRef(guid(prefix));
    return id.current;
}
